<div class="desktop-menu container-xl" [appStoryblok]="_editable">
  <div class="row row-cols-1 row-cols-lg-5 gx-3 align-items-stretch py-5">
    <div class="col" *ngFor="let blok of menus">
      <ndc-dynamic
        *ngIf="components"
        [ndcDynamicComponent]="components[blok.component]"
        [ndcDynamicInputs]="blok"
      >
      </ndc-dynamic>
    </div>
  </div>
</div>
